// import React, { useEffect, useState } from 'react'
// import { getAttendanceRegister,fetchgenerateAttendanceRegister, downloadAllAttenceRegister, downloadAttenceRegister } from './../../../../services/register_redux/register_actions/AttendanceRegister.action';
// import { useDispatch } from "react-redux";
// import { useParams } from 'react-router-dom';
// import $ from 'jquery';
// // fetchgenerateAttendanceRegister
// function AttendanceRegister({ setLoading, showSnackbar }) {
//     const [data, setGetData] = useState([])
//     const [file, setFile] = useState([])
//     const [editableRow, setEditableRow] = useState(null);
//     const [editedValues, setEditedValues] = useState({})
//     const dispatch = useDispatch();
//     const { date } = useParams();
//     const [checkedItems, setCheckedItems] = useState({});
//     const [isAllChecked, setIsAllChecked] = useState(false);
//     const [blobUrl, setBlobUrl] = useState('');
//     const [checkedItemCount, setCheckedItemCount] = useState(0);
//     const generateMonthHeaders = (year, month) => {
//         const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//         const monthIndex = month - 1; // Convert to zero-based index
//         const lastDay = new Date(year, month, 0).getDate();

//         const headers = [];
//         for (let day = 1; day <= lastDay; day++) {
//             const dayString = day.toString().padStart(2, '0');
//             headers.push({ key: `day_${dayString}`, value: `${monthNames[monthIndex]}-${dayString}` });
//         }

//         return headers;
//     };
//     const [year, month] = date.split('-').map(part => parseInt(part, 10));
//     const dateHeaders = generateMonthHeaders(year, month);
//     console.log("dateHeaders", dateHeaders)
//     const existingHeaders = [
//         { key: "emp_code", value: "Employee Code", readOnly:true   },
//         { key: "emp_Name", value: "Employee Name", readOnly:true   },
//         { key: "client_id", value: "Client ID",readOnly:true  },
//         { key: "unit_id", value: "Unit ID",readOnly:true  },
//         { key: "current_month", value: "Current Month" },
//         { key: "sick_leaves_opening_balance", value: "Sick Leaves Opening Balance" },
//         { key: "sick_leave_eligible_for_month", value: "Sick Leave Eligible For The Month" },
//         { key: "sick_leave_total_available", value: "Sick Leave Total Available" },
//         { key: "sick_leaves_taken", value: "Sick Leaves Taken" },
//         { key: "sick_leave_balance", value: "Sick Leave Balance" },
//         { key: "paid_leaves_opening_balance", value: "Paid Leaves Opening Balance" },
//         { key: "paid_leave_eligible_for_month", value: "Paid Leave Eligible for Month" },
//         { key: "paid_leave_total_available", value: "Paid Leave Total Available" },
//         { key: "paid_leaves_taken", value: "Paid Leaves Taken" },
//         { key: "paid_leave_balance", value: "Paid Leave Balance" },
//         { key: "maternity_leave", value: "Maternity Leave" },
//         { key: "total_leave_days", value: "Total Leave Days" },
//     ];

//     const header = [...existingHeaders, ...dateHeaders];



//     const fetchdata = async () => {
//         setLoading(true);
//         try {
//             // const response = await dispatch(getAttendanceRegister(date));
//             const response = await dispatch(fetchgenerateAttendanceRegister(date));

//             // setGetData(response.data.attendance_register);
//             setGetData(response.data.generated_attendance_register)
//             if(response.success === true) {
//                 // showSnackbar("Attendance data fetched successfully", 'success');
//                 setLoading(false);
//             }else{
//                 showSnackbar(response.message, 'warning');
//         setLoading(false);
//             }
//         } catch (err) {
//             console.error("Failed to fetch clients:", err);
//             // setLoading(false);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchdata();
//     }, [dispatch]);

//     const handleSearchClick = (e) => {
//         e.preventDefault();
//         const value = $('#searchInput').val().toLowerCase();
//         $('#dataTable tbody tr').each(function () {
//             const rowText = $(this).text().toLowerCase();
//             const isVisible = rowText.includes(value);
//             $(this).toggle(isVisible);
//         });
//     };
//     useEffect(() => {
//         const count = Object.values(checkedItems).filter(Boolean).length;
//         setCheckedItemCount(count);
//     }, [checkedItems]);
//     const handleCheckChange = (id) => {
//         setCheckedItems(prevCheckedItems => ({
//             ...prevCheckedItems,
//             [id]: !prevCheckedItems[id]
//         }));
//     };

//     const handleCheckAll = () => {
//         const newCheckedItems = { ...checkedItems };
//         const visibleRows = $('#dataTable tbody tr:visible');

//         const allVisibleChecked = visibleRows.toArray().every(row => {
//             const id = $(row).data('id');
//             return checkedItems[id];
//         });

//         const shouldCheck = !allVisibleChecked;

//         visibleRows.each(function () {
//             const id = $(this).data('id');
//             newCheckedItems[id] = shouldCheck;
//         });

//         setCheckedItems(newCheckedItems);
//     };
//     const calculateWidth = (text) => {
//         const charWidth = 10;
//         return `${text.length * charWidth}px`;
//     };
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setEditedValues({
//             ...editedValues,
//             [name]: value,
//         });
//     };
//     const updateCheckAllState = () => {
//         const allChecked = data.length > 0 && data.every(item => checkedItems[item.id]);
//         setIsAllChecked(allChecked);
//     };

//     useEffect(() => {
//         updateCheckAllState();
//     }, [checkedItems]);
//     const handledeletemultialert = (e) => {
//         e.preventDefault();
//         const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
//         const client_ID = sessionStorage.getItem('selectedClient')
//         const data = {
//             Client_ID: client_ID,
//             month: date
//         };
//         const selectedid = { ids: selectedIds, data: data };
//         submitdelete(selectedid);
//     }
//     const submitdelete = async (id) => {
//         setLoading(true);
//         if (checkedItemCount == 0) {
//             showSnackbar("select the row", 'warning');
//         } else {
//             try {
//                 const response = await dispatch(downloadAttenceRegister(id));
//                 if (response.success == true) {
//                     showSnackbar("downloadded", 'success');
//                     setLoading(false);
//                     fetchdata();
//                 } else {
//                     showSnackbar(response.message, 'warning');
//                     setLoading(false);
//                 }
//             } catch (error) {
//                 showSnackbar('An error occurred', 'error');
//                 setLoading(false);
//             }
//         }
//     }

//     const downloadAllAttendance = async () => {
//         const client_ID = sessionStorage.getItem('selectedClient')
//         const data = {
//             Client_ID: client_ID,
//             month: date
//         };
//         setLoading(true);
//         try {
//             const response = await dispatch(downloadAllAttenceRegister(data));
//             console.log("resData", response);
//             if (response.success == true) {
//                 showSnackbar("downloadded", 'success');
//                 setLoading(false);
//                 fetchdata();
//             } else {
//                 showSnackbar(response.message, 'warning');
//                 setLoading(false);
//             }
//         } catch (error) {
//             showSnackbar('An error occurred', 'error');
//             setLoading(false);
//         }
//     }
//     return (
//         <div>
//             <div className="col-md-12 py-3">
//                 <div className="card mx-2">
//                     <div className="card-header card-header-color py-0">
//                         <div className="col-md-12">
//                             <div className="row client-form-header ">
//                                 <div className="col-md-6 pt-2">
//                                     <h6 className='text-dark'>Attendance Register</h6>
//                                 </div>

//                                 <div className="col-md-6">
//                                     <a href="/forms" className='text-dark'><i className="bi bi-x float-end cancel-icon"></i></a>

//                                 </div>

//                             </div>

//                         </div>

//                     </div>

//                     <div className="card-body">
//                                                         <div className="col-md-9 pt-3  ">
//                                             <div className="row justify-content-between">
//                                                 <button
//                                                     className="btn btn-info text-white me-3 col-md-3"
//                                                     // onClick={() => setuploadVisible(!uploadFormVisible)}
//                                                 >
//                                                     <b>Attendance Register</b>
//                                                 </button>
//                                             </div>
//                                 </div>
//                         <div className="row">
//                             <div className="col-md-7">
//                                 {/* <button
//                                 className="btn btn-success text-white me-3 mt-2"
//                                 onClick={downloadAllAttendance}
//                                 >
//                                 <b>Download Excel</b>
//                             </button> */}
//                             </div>
//                             <div className="col-md-5">
//                                 <div className="row ">
//                                     <div className="col-md-12">
//                                         <div className="row">
//                                             <div className="col-md-12">
//                                                 <div className="col-md-4 d-flex search-div float-md-end responsiveSearch">
//                                                     <input
//                                                         type="text"
//                                                         placeholder="Search..."
//                                                         id="searchInput"
//                                                         className='bg-light '
//                                                     />
//                                                     <button onClick={handleSearchClick} className='search-submit bg-light'><i className="bi bi-search "></i></button>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-md-12">

//                                 <div className="row justify-content-between">
//                                     <div className="col-md-7">

//                                     </div>
//                                     <div className="col-md-5 ">
//                                     </div>

//                                 </div>
//                                 <div className="card">
//                                     {/* onSubmit={handledeletemultialert} */}
//                                     <form onSubmit={handledeletemultialert}>
//                                         <div className="card-header">
//                                             <div className="col-md-12">
//                                                 <div className="row justify-content-between">
//                                                     {/* <div className="col-md-11 d-flex justify-content-between">
//                                                         <div className=' pt-1 client-2nd-header-size m-0 '>
//                                                             <p className="col-md-12 m-0">
//                                                                 Total Entries: {data ? data.length : 0}
//                                                             </p>
//                                                         </div>
//                                                         <p className='pt-1 m-0 client-2nd-header-size'>Selected Entries:0</p>
//                                                     </div> */}
//                                                     {/* <div className="col-md-1" >
//                                                         <div className="row">
//                                                             <div className="dropdown col-md-12 p-0 ">
//                                                                 <button className="btn p-0 float-end" type="button" data-bs-toggle="dropdown" aria-expanded="false">
//                                                                     <i className="bi bi-three-dots-vertical"></i>
//                                                                 </button>
//                                                                 <ul className="dropdown-menu btn-z-indexer">
//                                                                     <li><button className="dropdown-item " type='submit'>Download Selected</button></li>
//                                                                 </ul>
//                                                             </div>
//                                                         </div>
//                                                     </div> */}
//                                                     <div className="col-md-6">
//                                                         <div className="row">
//                                                             <p className='pt-1 m-0 client-2nd-header-size col-md-3'>Selected Entries: {checkedItemCount}</p>

//                                                         </div>
//                                                     </div>
                                                    // <div className="col-md-6">
                                                    //     <div className="row float-end">
                                                    //         <p className='col-md-11 pt-1 client-2nd-header-size m-0'>Total Entries: {data ? data.length : 0}</p>
                                                    //         <div className="dropdown col-md-1 p-0 bg-transparent">
                                                    //             <button className=" p-0 pt-2 w-0 border-0 btn-transparent " type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    //                 <i className="bi bi-three-dots-vertical"></i>
                                                    //             </button>
                                                    //             <ul className="dropdown-menu btn-z-indexer">
                                                    //                 <li><button className="dropdown-item " type='submit'>Download Selected</button></li>
                                                    //             </ul>
                                                    //         </div>
                                                    //     </div>
                                                    // </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="card-body m-0 p-0">
//                                             <div className="table-responsive" style={{ maxHeight: "350px" }}>
//                                                 {data !== 0 && header !== 0 ? (
//                                                     <table className='table table-bordered tablefontsize' id='dataTable'>
//                                                         <thead className='sticky-top'>
//                                                             <tr >
//                                                                 <th className='bg-light'><input type="checkbox" checked={isAllChecked} onChange={handleCheckAll} name="" id="" /></th>
//                                                                 <th className='slnowidth bg-light'><span>SL NO</span></th>
//                                                                 {header.map(headerItem => (
//                                                                     <th key={headerItem.key} style={{ minWidth: calculateWidth(headerItem.value) }} className='bg-light'>{headerItem.value}</th>
//                                                                 ))}
//                                                                 {/* <th className='bg-light'>Action</th> */}
//                                                             </tr>
//                                                         </thead>
//                                                         <tbody>
//                                                             {data ? (
//                                                                 <>
//                                                                     {data.map((item, index) => (
//                                                                         <tr key={index}  data-id={item.id}>
//                                                                             <td><input type="checkbox" name="" id="" checked={checkedItems[item.id] || false} onChange={() => handleCheckChange(item.id)} /></td>
//                                                                             <td>{index + 1}</td>
//                                                                             {header.map(headerItem => (
//                                                                                 <td key={headerItem.key}>
//                                                                                     {editableRow === item.id ? (
//                                                                                         <input
//                                                                                             type={headerItem.input}
//                                                                                             value={editedValues[headerItem.key]}
//                                                                                             name={headerItem.key}
//                                                                                             onChange={handleInputChange}
//                                                                                             readOnly={header.readOnly}
//                                                                                         />
//                                                                                     ) : (
//                                                                                         item[headerItem.key]
//                                                                                     )}
//                                                                                 </td>
//                                                                             ))}
//                                                                             {/* <td className='text-center'>
//                                                                         {editableRow === item.id ? (
//                                                                             <div className="d-flex justify-content-between">
//                                                                             <span onClick={handleSavealert} className='btn p-0'><i className="bi bi-save-fill text-success auction-btn"></i></span>
//                                                                             <span onClick={handleCancelClick} className='btn p-0'><i className="bi bi-x-circle text-info auction-btn"></i></span>
//                                                                             </div>
//                                                                         ) : (
//                                                                             <div className="d-flex justify-content-between">
//                                                                             <span onClick={() => handleEditClick(item.id)} className='btn p-0'><i className="bi bi-pencil-square text-info auction-btn"></i></span>
//                                                                             <span onClick={() => handledeletealert(item.id)} className='btn p-0'><i className="bi bi-trash3-fill text-danger auction-btn"></i></span>
//                                                                             </div>
//                                                                         )}
//                                                                         </td> */}
//                                                                         </tr>
//                                                                     ))}
//                                                                 </>
//                                                             ) : (
//                                                                 <tr>
//                                                                     no data
//                                                                 </tr>
//                                                             )}
//                                                         </tbody>
//                                                     </table>
//                                                 ) : (
//                                                     <h1>no data</h1>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </form>
//                                 </div>
//                             </div>
//                             {/* <Dialog
//                                 open={openeditalert}
//                                 TransitionComponent={Transition}
//                                 keepMounted
//                                 aria-describedby="alert-dialog-slide-description"
//                             >
//                                 <DialogTitle>{"Are you sure?"}</DialogTitle>
//                                 <DialogContent>
//                                 <DialogContentText id="alert-dialog-slide-description">
//                                 Are you sure you want to edit this {title}? Any unsaved changes might be lost.
//                                 </DialogContentText>
//                                 </DialogContent>
//                                 <DialogActions>
//                                 <Button onClick={handleCloseeditalert}>No</Button>
//                                 <Button onClick={handleSaveClickconfirmed}>Yes</Button>
//                                 </DialogActions>
//                             </Dialog>
//                             <Dialog
//                                 open={opendeletealert}
//                                 TransitionComponent={Transition}
//                                 keepMounted
//                                 aria-describedby="alert-dialog-slide-description"
//                             >
//                                 <DialogTitle>{"Are you sure?"}</DialogTitle>
//                                 <DialogContent>
//                                 <DialogContentText id="alert-dialog-slide-description">
//                                 Are you sure you want to delete this {title}? This action cannot be undone.

//                                 </DialogContentText>
//                                 </DialogContent>
//                                 <DialogActions>
//                                 <Button onClick={handledeleteClosealert}>No</Button>
//                                 <Button onClick={handledeleteClickconfirmed}>Yes</Button>
//                                 </DialogActions>
//                             </Dialog>
//                             <Dialog
//                                 open={opendeletemultialert}
//                                 TransitionComponent={Transition}
//                                 keepMounted
//                                 aria-describedby="alert-dialog-slide-description"
//                             >
//                                 <DialogTitle>{"Are you sure?"}</DialogTitle>
//                                 <DialogContent>
//                                 <DialogContentText id="alert-dialog-slide-description">
//                                 Are you sure you want to delete those {title}? This action cannot be undone.

//                                 </DialogContentText>
//                                 </DialogContent>
//                                 <DialogActions>
//                                 <Button onClick={handledeletemultiClosealert}>No</Button>
//                                 <Button onClick={selectedDelete}>Yes</Button>
//                                 </DialogActions>
//                             </Dialog> */}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default AttendanceRegister




import React, { useEffect, useState } from 'react';
import {
  getAttendanceRegister,
  fetchgenerateAttendanceRegister,
  downloadAllAttenceRegister,
  downloadAttenceRegister,deleteSingleAttendanceById,multiDeleteAttendanceRegister,regenerateAttendance
} from './../../../../services/register_redux/register_actions/AttendanceRegister.action';
import { getLeaveMaster } from './../../../../services/register_redux/register_actions/Leave.action';
import { getCurrentMonth } from './../../../../services/global_redux/globale_actions/Currentmonth.action';
import { useDispatch } from "react-redux";
import { useParams } from 'react-router-dom';
import $ from 'jquery';
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileform from '../../../reUsableTemplates/ImportFileform/ImportFileform'
import mainicon from "../../../../assets/global_assets/holiday_table/table_main_icon.png"
import ImportFileformInputMatrixclientData from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrixclientData'

function AttendanceRegister({ setLoading, showSnackbar }) {
  const [data, setGetData] = useState([]);
  const [editableRow, setEditableRow] = useState(null);
  const [editedValues, setEditedValues] = useState({});
  const [checkedItems, setCheckedItems] = useState({});
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [checkedItemCount, setCheckedItemCount] = useState(0);
  const [showRegisterBtn, setShowRegisterBtn] = useState(false);
  const [currentMonthIssame, setCurrentMonthIssame] = useState(false);

  const dispatch = useDispatch();
  const { date } = useParams();
  const current_month = date;
  const [year, month] = date.split('-').map(part => parseInt(part, 10));
  const [dynamicHeaders, setDynamicHeaders] = useState(null);
  const [leaveCodes, setLeaveCodes] = useState([]);

  const generateMonthHeaders = (year, month) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthIndex = month - 1;
    const lastDay = new Date(year, month, 0).getDate();

    const headers = [];
    for (let day = 1; day <= lastDay; day++) {
      const dayString = day.toString().padStart(2, '0');
      headers.push({ key: `day_${dayString}`, value: `${monthNames[monthIndex]}-${dayString}` });
    }
    return headers;
  };

  const dateHeaders = generateMonthHeaders(year, month);

  // Base fixed columns; all leave-specific columns will be added dynamically
  const existingHeaders = [
    { key: "emp_code", value: "Employee Code", readOnly: true },
    { key: "emp_Name", value: "Employee Name", readOnly: true },
    { key: "client_id", value: "Organization ID", readOnly: true },
    { key: "unit_id", value: "Branch ID", readOnly: true },
    { key: "current_month", value: "Current Month" }
  ];

  const [actionChecked, setActionChecked] = useState("");

  const header = [
    ...(dynamicHeaders || existingHeaders),
    ...dateHeaders
  ];

//   const fetchdata = async () => {
//     setLoading(true);
//     const client_ID = sessionStorage.getItem('selectedClient');
//     try {
//       const checkData = await dispatch(getAttendanceRegister(date));
//       if (checkData?.data?.attendance_register?.length > 0) {
//         setShowRegisterBtn(false);
//         const response = await dispatch(fetchgenerateAttendanceRegister(date));
//         if (response.success === true) {
//           setGetData(response.data.generated_attendance_register);
//         } else {
//           showSnackbar(response.message, 'warning');
//         }
//       } else {
//         setGetData([]);
//         setShowRegisterBtn(true);
//       }
//     } catch (err) {
//       showSnackbar("Error occurred while fetching data", 'error');
//     } finally {
//       setLoading(false);
//     }
//   };
const fetchdata = async () => {
  setLoading(true);
  try {
    const response = await dispatch(fetchgenerateAttendanceRegister(date));
    const generatedData = response?.data?.generated_attendance_register;
    const leave_codes = response?.data?.leave_codes || [];

    if (response.success === true && generatedData?.length > 0) {
      const flattened = generatedData.map(row => {
        const lb = row.leave_balances || {};
        const flat = { ...row };
        leave_codes.forEach(code => {
          const vals = lb[code] || {};
          flat[`lb_${code}_opening_balance`] = vals.opening_balance ?? '';
          flat[`lb_${code}_eligible_for_month`] = vals.eligible_for_month ?? '';
          flat[`lb_${code}_total_available`] = vals.total_available ?? '';
          flat[`lb_${code}_taken`] = vals.taken ?? '';
          flat[`lb_${code}_balance`] = vals.balance ?? '';
        });
        return flat;
      });

      setLeaveCodes(leave_codes);
      setGetData(flattened);
      setShowRegisterBtn(false);
    } else {
      setGetData([]);
      setShowRegisterBtn(true);
    }
  } catch (err) {
    console.error("Error in fetchdata:", err);
    showSnackbar("Failed to fetch attendance data", 'error');
    setShowRegisterBtn(true);
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    fetchdata();
    // fetchOrGenerateAttendance();
  }, [dispatch]);

  // Build dynamic leave columns (5 per leave code) based on LeaveMaster + leaveCodes from backend
  useEffect(() => {
    const buildDynamicHeaders = async () => {
      try {
        const resp = await dispatch(getLeaveMaster());
        if (!resp?.success || !Array.isArray(resp.data)) return;

        const leaves = resp.data;
        const codeToName = {};
        leaves.forEach(l => {
          if (!l.leave_code) return;
          codeToName[l.leave_code] = l.leave_name || l.display_leave_code || l.leave_code;
        });

        // Enforce header order: SL, CL, EL, PL, others, ML last
        const priority = ['SL', 'CL', 'EL', 'PL', 'ML'];
        const orderedCodes = [...leaveCodes].sort((a, b) => {
          const ia = priority.indexOf(a);
          const ib = priority.indexOf(b);

          const aKnown = ia !== -1;
          const bKnown = ib !== -1;

          if (aKnown && bKnown) return ia - ib;
          if (aKnown && !bKnown) {
            // known vs unknown → keep known where it is
            return ia - priority.length + 1;
          }
          if (!aKnown && bKnown) {
            return priority.length - 1 - ib;
          }
          // both unknown: alphabetical
          return a.localeCompare(b);
        });

        const leaveHeaders = [];
        orderedCodes.forEach(code => {
          const name = codeToName[code] || code;
          leaveHeaders.push(
            { key: `lb_${code}_opening_balance`,   value: `${name} Opening Balance` },
            { key: `lb_${code}_eligible_for_month`, value: `${name} Eligible For The Month` },
            { key: `lb_${code}_total_available`,   value: `${name} Total Available` },
            { key: `lb_${code}_taken`,             value: `${name} Taken` },
            { key: `lb_${code}_balance`,           value: `${name} Balance` },
          );
        });
        const leaveHeadAdd = [
            { key: "total_leave_days", value: "Total Leave Balance" }]
        setDynamicHeaders([...existingHeaders, ...leaveHeaders, ...leaveHeadAdd]);
      } catch (e) {
        console.error("Failed to build dynamic attendance headers from LeaveMaster", e);
      }
    };

    if (leaveCodes.length > 0) {
      buildDynamicHeaders();
    }
  }, [dispatch, leaveCodes]);

const handleGenerateAttendance = async () => {
    setLoading(true);
    try {
        const response = await dispatch(getAttendanceRegister(date));
        if (response.success === true) {
            showSnackbar("Attendance Register Generated Successfully", 'success');
            fetchdata(); // Reload to fetch newly generated data
        } else {
            showSnackbar(response.error.error || "Failed to generate attendance", 'warning');
        }
    } catch (err) {        
        showSnackbar("Error generating attendance", 'error');
    } finally {
        setLoading(false);
    }
};



const handleReGenerateAttendance = async () => {
    setLoading(true);
    try {
        const response = await dispatch(regenerateAttendance(date));
        if (response.success === true) {
            showSnackbar("Attendance Register Generated Successfully", 'success');
            fetchdata(); // Reload to fetch newly generated data
        } else {
            showSnackbar(response.error.error || "Failed to generate attendance", 'warning');
        }
    } catch (err) {        
        showSnackbar("Error generating attendance", 'error');
    } finally {
        setLoading(false);
    }
};




  const handleSearchClick = (e) => {
    e.preventDefault();
    const value = $('#searchInput').val().toLowerCase();
    $('#dataTable tbody tr').each(function () {
      const rowText = $(this).text().toLowerCase();
      $(this).toggle(rowText.includes(value));
    });
  };

  const handleCheckChange = (id) => {
    setCheckedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  useEffect(() => {
    const count = Object.values(checkedItems).filter(Boolean).length;
    setCheckedItemCount(count);
    const allChecked = data.length > 0 && data.every(item => checkedItems[item.id]);
    setIsAllChecked(allChecked);
  }, [checkedItems]);

  const handleCheckAll = () => {
    const visibleRows = $('#dataTable tbody tr:visible');
    const shouldCheck = !visibleRows.toArray().every(row => checkedItems[$(row).data('id')]);
    const newCheckedItems = { ...checkedItems };
    visibleRows.each(function () {
      const id = $(this).data('id');
      newCheckedItems[id] = shouldCheck;
    });
    setCheckedItems(newCheckedItems);
  };

  const calculateWidth = (text) => {
    const charWidth = 10;
    return `${text.length * charWidth}px`;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedValues(prev => ({ ...prev, [name]: value }));
  };

  const handledeletemultialert = async (e) => {
    e.preventDefault();
    if (checkedItemCount === 0) {
      showSnackbar("Select the row", 'warning');
      return;
    }
    const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[id]).map(Number);
    const client_ID = sessionStorage.getItem('selectedClient');
    const data = { Client_ID: client_ID, month: date };
    const payload = { ids: selectedIds, data };

    try {
      setLoading(true);
      const response = await dispatch(downloadAttenceRegister(payload));
      if (response.success === true) {
        showSnackbar("Downloaded", 'success');
        fetchdata();
      } else {
        showSnackbar(response.message, 'warning');
      }
    } catch (err) {
      showSnackbar('An error occurred', 'error');
    } finally {
      setLoading(false);
    }
  };

  const downloadAllAttendance = async () => {
    const client_ID = sessionStorage.getItem('selectedClient');
    const data = { Client_ID: client_ID, month: date };

    try {
      setLoading(true);
      const response = await dispatch(downloadAllAttenceRegister(data));
      if (response.success === true) {
        showSnackbar("Downloaded", 'success');
        fetchdata();
      } else {
        showSnackbar(response.message, 'warning');
      }
    } catch (err) {
      showSnackbar('An error occurred', 'error');
    } finally {
      setLoading(false);
    }
  };

  const fetchcurrmonth = async () => {
    try {
        const response = await dispatch(getCurrentMonth());
        const rawDate = response.data[0].current_month;
        const currdate = new Date(rawDate);

        if (!isNaN(currdate)) {
            const year = currdate.getFullYear();
            const month = String(currdate.getMonth() + 1).padStart(2, '0');
            const day = String(currdate.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            if(formattedDate == date){
                setCurrentMonthIssame(true)
            }

        } else {
            console.error('Invalid date:', rawDate);
        }

    } catch (err) {
        console.error("Failed to fetch clients:", err);
    }
};


const handledeleteClickOpenalert = async (id) => {
  setLoading(true);
  try {
    const response = await dispatch(deleteSingleAttendanceById(id));
  if (response.success == true) {
    showSnackbar(response.message, 'success');
    setLoading(false);
    setEditableRow(null);
    fetchdata();
    setActionChecked("delete");
  } else {
    showSnackbar(response.message, 'warning');
    setLoading(false);
  }
} catch (error) {
    showSnackbar('An error occurred', 'error');
    setLoading(false);
}
};
    
const submitdelete = async (id) => {
  setLoading(true);
  try {
      const response = await dispatch(multiDeleteAttendanceRegister(id));
      if (response.success == true) {
          showSnackbar(response.message.message, 'success');
          setLoading(false);
          fetchdata();
          setActionChecked("delete");
      } else {
          showSnackbar(response.message, 'warning');
          setLoading(false);
      }
  } catch (error) {
      showSnackbar('An error occurred', 'error');
      setLoading(false);
  }

}


useEffect(() => {
    fetchcurrmonth();
}, [dispatch]);
  return (
    <div className="col-md-12 py-3">
      {/* <div className="card mx-2">
        <div className="card-header card-header-color py-0">
          <div className="row client-form-header">
            <div className="col-md-6 pt-2">
              <h6 className='text-dark'>Attendance Register</h6>
            </div>
            <div className="col-md-6">
              <a href={`/input-matrix/${current_month}`} className='text-dark'><i className="bi bi-x float-end cancel-icon"></i></a>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="row justify-content-between pt-3">
            {currentMonthIssame &&
                <>
                    {showRegisterBtn ? (
                        <button
                            className="btn btn-info text-white me-3 col-md-3"
                            onClick={handleGenerateAttendance}
                        >
                            <b>Generate Attendance Register</b>
                        </button>
                        ):(
                            <button
                            className="btn btn-info text-white me-3 col-md-3"
                            onClick={handleGenerateAttendance}
                        >
                            <b>Re-generate Attendance Register</b>
                        </button>
                    )}
                </>

            }
          </div>

          <div className="row">
            <div className="col-md-7"></div>
            <div className="col-md-5">
              <div className="search-div float-end responsiveSearch d-flex">
                <input type="text" placeholder="Search..." id="searchInput" className='bg-light' />
                <button onClick={handleSearchClick} className='search-submit bg-light'><i className="bi bi-search"></i></button>
              </div>
            </div>

            <div className="col-md-12 mt-3">
              <form onSubmit={handledeletemultialert}>
                <div className="card">
                  <div className="card-header">
                    <div className="row justify-content-between">
                      <div className="col-md-6">
                        <p className='pt-1 m-0 client-2nd-header-size'>Selected Entries: {checkedItemCount}</p>
                      </div>
                      <div className="col-md-6">
                        <div className="row float-end">
                            <p className='col-md-11 pt-1 client-2nd-header-size m-0'>Total Entries: {data ? data.length : 0}</p>
                            <div className="dropdown col-md-1 p-0 bg-transparent">
                                <button className=" p-0 pt-2 w-0 border-0 btn-transparent " type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="bi bi-three-dots-vertical"></i>
                                </button>
                                <ul className="dropdown-menu btn-z-indexer">
                                    <li><button className="dropdown-item " type='submit'>Download Selected</button></li>
                                </ul>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body m-0 p-0">
                    <div className="table-responsive" style={{ maxHeight: "350px" }}>
                      {data.length > 0 && header.length > 0 ? (
                        <table className='table table-bordered tablefontsize' id='dataTable'>
                          <thead className='sticky-top'>
                            <tr>
                              <th className='bg-light'><input type="checkbox" checked={isAllChecked} onChange={handleCheckAll} /></th>
                              <th className='bg-light'>SL NO</th>
                              {header.map(headerItem => (
                                <th key={headerItem.key} style={{ minWidth: calculateWidth(headerItem.value) }} className='bg-light'>
                                  {headerItem.value}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((item, index) => (
                              <tr key={index} data-id={item.id}>
                                <td><input type="checkbox" checked={checkedItems[item.id] || false} onChange={() => handleCheckChange(item.id)} /></td>
                                <td>{index + 1}</td>
                                {header.map(headerItem => (
                                  <td key={headerItem.key}>
                                    {editableRow === item.id ? (
                                      <input
                                        type="text"
                                        value={editedValues[headerItem.key]}
                                        name={headerItem.key}
                                        onChange={handleInputChange}
                                        readOnly={headerItem.readOnly}
                                      />
                                    ) : (
                                      item[headerItem.key]
                                    )}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <p className="p-3">No data available</p>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div> */}
            <ImportFileformInputMatrixclientData
              date={date}                
            />
            <EditableTable
            
            header={header}
            mainIcon={mainicon}
            title={'Attendance Register'}
            data={data}
            // setEditableRow={setEditableRow}
            // setEditedValues={setEditedValues}
            handledeleteClickOpenalert={handledeleteClickOpenalert}
            // editableRow={editableRow}
            setLoading={setLoading}
            // editedValues={editedValues}
            getEditPermission = {false}
            getDeletePermission = {false}
            date={date}
            submitdelete={submitdelete}
            // handleSaveClick={handleSaveClick}
            showSnackbar={showSnackbar}
            actionChecked={actionChecked}
            setActionChecked={setActionChecked}
            createOrfilterComp={
              currentMonthIssame &&
                <>
                    {showRegisterBtn ? (
                        <button
                            className="btn btn-info text-white me-3 col-md-3"
                            onClick={handleGenerateAttendance}
                        >
                            <b>Generate Attendance Register</b>
                        </button>
                        ):(
                            <button
                            className="btn btn-info text-white me-3 col-md-3"
                            onClick={handleReGenerateAttendance}
                        >
                            <b>Re-generate Attendance Register</b>
                        </button>
                    )}
                </>
            }
            />
    </div>
  );
}

export default AttendanceRegister;


